import { createBrowserRouter } from "react-router-dom";
import {
    LoginPage,
    EasyLoginPage,
    Layout,
    NotFoundPage,
    ExamplePage,
    HomePage,
    DigitalWalletPage,
    TransactionsPage,
} from "@/pages";
import Employees from "./components/employees/employees";
import AllTransactionsPage from "@/pages/transaction/allTransactions.page";
import CreateEmployee from "./components/employees/createEmployee/createEmployee";
import EmployeePage from "./components/employees/employeePage/employeePage";
import EmployeeGeneralInfo from "./components/employees/employeeGeneralInfo/employeeGeneralInfo";
import DigitalWalletListPage from "./pages/digitalWallet/digital.wallet.list.page";
import DigitalWalletManagementPage from "./pages/digitalWallet/digital.wallet.management.page";
import EmployeeDigitalWallet from "./components/employees/employeeDigitalWallet/employeeDigitalWallet";
import EmployeeOrders from "./components/employees/employeeOrders/employeeOrders";
import Orders from "./components/orders";
import OrderDetails from "./components/orders/orderDetails";
import EmployeeAttachedDocs from "./components/employees/employeeAttachedDocs/employeeAttachedDocs";
import Forms from "./components/forms/forms";
import FormsCreateFunDay from "./components/forms/formsCreateFunDay/formsCreateFunDay";
import FormsCreateGroupOrder from "./components/forms/formsCreateGroupOrder/formsCreateGroupOrder";
import Accounting from "./components/accounting/accountingDocs";
import AccountingInvoice from "./components/accounting/accountingDocsInvoice";
import AccountingReceipt from "./components/accounting/accountingDocsReceipt";
import Messages from "./components/messages/messages";
import ImportEmployees from "./components/employees/import/import";
import SettingsPage from "@/pages/settings/settings.page";
import SettingsUsersPage from "@/pages/settings/users/users.page";
import SettingsUserDetailsPage from "@/pages/settings/users/user.page.detail";
import SettingsProfilesPage from "@/pages/settings/profiles/profiles.page";
import SettingsInterfacesPage from "@/pages/settings/interfaces/interfaces.page";
import SettingsImportPage from "@/pages/settings/import/import.page";
import InterfacesTransaction from "./pages/settings/interfaces/InterfacesTransaction";
import OrganizationManagementList from "@/pages/settings/organizationUnitsManagement/organizationUnitsManagementList";
import EmployeeGroups from "@/pages/settings/employeeGroupsManagement/employeeGroupsManagementList";
import EmployeeGroupsManagementList from "@/pages/settings/employeeGroupsManagement/employeeGroupsManagementList";
import OrganizationUnitsManagementList from "@/pages/settings/organizationUnitsManagement/organizationUnitsManagementList";

const router = createBrowserRouter([
    {
        path: "/login",
        element: <LoginPage />,
    },
    {
        path: "/easy-login",
        element: <EasyLoginPage />,
    },
    {
        element: <Layout />,
        children: [
            {
                path: "/",
                element: <HomePage />,
            },
            {
                path: "/employees",
                element: <Employees />,
            },
            {
                path: "/employees/createEmployee",
                element: <CreateEmployee />,
            },
            {
                path: "/employees/:id",
                children: [
                    { path: "/employees/:id/info", element: <EmployeeGeneralInfo /> },
                    { path: "/employees/:id/wallet", element: <EmployeeDigitalWallet /> },
                    { path: "/employees/:id/employeeOrders", element: <EmployeeOrders /> },
                    { path: "/employees/:id/docs", element: <EmployeeAttachedDocs /> },
                ],
                element: <EmployeePage />,
            },
            {
                path: "/employees/import",
                element: <ImportEmployees />,
            },
            {
                path: "/digital-wallet",
                element: <DigitalWalletPage />,
            },
            {
                path: "/digital-wallet/list/:id/transactions",
                element: <TransactionsPage />,
            },
            {
                path: "/digital-wallet/transactions",
                element: <AllTransactionsPage />,
            },
            {
                path: "/digital-wallet/list",
                element: <DigitalWalletListPage />,
            },
            {
                path: "/digital-wallet/management",
                element: <DigitalWalletManagementPage />,
            },
            {
                path: "/orders",
                element: <Orders />,
            },
            {
                path: "/forms",
                element: <Forms />,
            },
            {
                path: "/forms/createFunDay",
                element: <FormsCreateFunDay />,
            },
            {
                path: "/forms/createGroupOrder",
                element: <FormsCreateGroupOrder />,
            },
            {
                path: "/orders/:orderId",
                element: <OrderDetails backButtonNameKey="general.backToOrders" />,
            },
            {
                path: "/employees/:employeeId/employeeOrders/:orderId",
                element: <OrderDetails backButtonNameKey="general.backToEmployeeOrders" />,
            },
            {
                path: "/employees/:employeeId/wallet/:orderId",
                element: <OrderDetails backButtonNameKey="general.backToEmployeeWallet" />,
            },
            {
                path: "/digital-wallet/list/:transactionId/transactions/:orderId",
                element: <OrderDetails backButtonNameKey="general.backToTransactions" />,
            },
            {
                path: "/accounting/invoice/:id/:orderId",
                element: <OrderDetails backButtonNameKey="general.backToInvoice" />,
            },
            {
                path: "/example",
                element: <ExamplePage />,
            },
            {
                path: "/accounting",
                element: <Accounting />,
            },
            {
                path: "/accounting/invoice/:id",
                element: <AccountingInvoice />,
            },
            {
                path: "/accounting/receipt/:id",
                element: <AccountingReceipt />,
            },
            {
                path: "/messages",
                element: <Messages />,
            },
            {
                path: "/settings",
                element: <SettingsPage />,
                children: [
                    {
                        path: "/settings/manage-users",
                        element: <SettingsUsersPage />,
                        children: [
                            {
                                path: "/settings/manage-users/user/:userId?",
                                element: <SettingsUserDetailsPage />,
                            },
                        ],
                    },
                    {
                        path: "/settings/manage-profiles",
                        element: <SettingsProfilesPage />,
                    },
                    {
                        path: "/settings/manage-import",
                        element: <SettingsImportPage />,
                    },
                    {
                        path: "/settings/manage-interface",
                        element: <SettingsInterfacesPage />,
                    },
                    {
                        path: "/settings/manage-interface/transactions/:interfaceId",
                        element: <InterfacesTransaction />,
                    },
                    {
                        path: "/settings/manage-organization-units",
                        element: <OrganizationUnitsManagementList />,
                    },
                    {
                        path: "/settings/manage-employee-groups",
                        element: <EmployeeGroupsManagementList />,
                    },
                ],
            },
        ],
    },

    {
        path: "*",
        element: <NotFoundPage />,
    },
]);

export default router;
